export default "__VITE_ASSET__DSV8dzqp__"